import { TrackChangesFormatBaseValueConverter } from 'General/Resources/ValueConverters/TrackChangesFormatBase';

export class TrackChangesFormatValueConverter extends TrackChangesFormatBaseValueConverter{

}